/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
const removeExecutionMessage = (str: string) => str?.split("execution reverted:").pop();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const parseError = (error: Error | any) => {
  console.log("🚀 ~ file: parse-error.ts:5 ~ parseError ~ error:", error);
  let errorMessage = "";
  if (error?.data?.message) {
    errorMessage = error?.data?.message;
  } else if (error?.reason) {
    errorMessage = error?.reason;
  } else {
    errorMessage = error?.message;
  }
  errorMessage = removeExecutionMessage(errorMessage) || "";
  return errorMessage;
};
